import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "primary-container mt-4" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"bg-yellow-50 border-l-4 border-yellow-400 p-4 mb-4 rounded-lg\"><div class=\"flex\"><div class=\"flex-shrink-0\"><svg class=\"h-6 w-6 text-yellow-500\" fill=\"currentColor\" viewBox=\"0 0 20 20\"><path fill-rule=\"evenodd\" d=\"M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l6.518 11.59c.75 1.333-.213 2.99-1.742 2.99H3.482c-1.53 0-2.493-1.657-1.743-2.99L8.257 3.1zM11 13a1 1 0 10-2 0 1 1 0 002 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z\" clip-rule=\"evenodd\"></path></svg></div><div class=\"ml-3\"><p class=\"text-base font-medium text-yellow-800\"> Editing public API keys can break a school group&#39;s integration. </p><p class=\"text-sm text-yellow-700 mt-1\"> Regenerating, deactivating, or deleting a key will immediately stop any client currently using it. Proceed with care. </p></div></div></div>", 1)
const _hoisted_3 = { class: "shadow-lg px-6 py-4 bg-white rounded-2xl mb-6" }
const _hoisted_4 = { class: "flex items-center justify-between mb-3" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h1", { class: "text-dark-grey font-medium text-xl" }, "Public API Keys", -1)
const _hoisted_6 = { class: "flex items-center gap-3" }
const _hoisted_7 = {
  key: 0,
  class: "flex justify-center my-10"
}
const _hoisted_8 = {
  key: 1,
  class: "shadow-lg p-8 bg-white rounded-2xl text-center"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h2", { class: "text-xl font-medium text-gray-800 mb-3" }, " No API key exists for this school group ", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-600 mb-6" }, " Generate a new public API key to enable self-service API access for this school group. ", -1)
const _hoisted_11 = {
  key: 2,
  class: "shadow-lg p-6 bg-white rounded-2xl mb-6"
}
const _hoisted_12 = { class: "flex items-center justify-between mb-6" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h2", { class: "text-xl font-medium text-gray-800" }, "API Key", -1)
const _hoisted_14 = { class: "grid grid-cols-1 sm:grid-cols-2 gap-4 mb-6 text-sm text-gray-700" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-500" }, "Created", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-500" }, "Last updated", -1)
const _hoisted_17 = { class: "mb-6" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { class: "block text-sm text-gray-500 mb-2" }, "Access Token", -1)
const _hoisted_19 = { class: "flex items-center gap-3" }
const _hoisted_20 = { class: "relative flex-1" }
const _hoisted_21 = ["value"]
const _hoisted_22 = {
  key: 0,
  class: "absolute inset-0 flex items-center justify-center pointer-events-none"
}
const _hoisted_23 = ["disabled"]
const _hoisted_24 = ["disabled"]
const _hoisted_25 = { class: "flex flex-wrap gap-3 pt-4 border-t border-gray-200" }
const _hoisted_26 = { class: "relative px-4 pt-5 pb-4" }
const _hoisted_27 = { class: "mt-3 text-center sm:mt-5" }
const _hoisted_28 = { class: "text-lg leading-6 font-medium text-gray-900" }
const _hoisted_29 = { class: "mt-2" }
const _hoisted_30 = ["innerHTML"]
const _hoisted_31 = { class: "mt-5 sm:mt-6 sm:flex sm:flex-row-reverse" }
const _hoisted_32 = ["disabled"]
const _hoisted_33 = ["disabled"]
const _hoisted_34 = { class: "px-6 py-5 max-h-[80vh] overflow-y-auto" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("h3", { class: "text-xl font-semibold text-gray-900 mb-1" }, "Getting Started", -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-gray-500 mb-5" }, "Public API quick-start guide", -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("section", { class: "mb-5" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2" }, "REST API Basics"),
  /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-gray-600 leading-relaxed" }, [
    /*#__PURE__*/_createTextVNode(" The Reflective Learning Public API is a RESTful JSON API. All requests must include an "),
    /*#__PURE__*/_createElementVNode("code", { class: "bg-gray-100 px-1 rounded font-mono text-sm" }, "Authorization: Bearer <token>"),
    /*#__PURE__*/_createTextVNode(" header, where the token is the school group's active API key. Request bodies use "),
    /*#__PURE__*/_createElementVNode("code", { class: "bg-gray-100 px-1 rounded font-mono text-sm" }, "Content-Type: application/json"),
    /*#__PURE__*/_createTextVNode(". Successful responses creates return a "),
    /*#__PURE__*/_createElementVNode("code", { class: "bg-gray-100 px-1 rounded font-mono text-sm" }, "2xx"),
    /*#__PURE__*/_createTextVNode(" status with a JSON body. ")
  ])
], -1)
const _hoisted_38 = { class: "mb-5" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("h4", { class: "text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2" }, "Base URL", -1)
const _hoisted_40 = { class: "bg-gray-50 border border-gray-200 rounded-lg px-4 py-3 text-sm font-mono overflow-x-auto" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("h4", { class: "text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2" }, "Example: Create a Student", -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("h4", { class: "text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2" }, "Expected Response: 200", -1)

import { ref, computed, onMounted, watch } from "vue";
import { useSchoolGroupStore } from "@/stores/schoolGroupsStore";
import { usePublicApiKeyStore } from "@/stores/publicApiKeyStore";
import { useActivityLogStore } from "@/stores/activityLogStore";
import { showToast } from "@/utils/toastUtils";
import { SchoolGroup } from "@/interfaces/school-group.interface";

const expectedResponse = `{
    "message": "Student created successfully.",
    "studentId": "uFgD26jLb3cXba3PtZOd4BoVept2"
}`;

type Action = "create" | "regenerate" | "deactivate" | "reactivate" | "delete";


export default /*#__PURE__*/_defineComponent({
  __name: 'PublicAPIKeysComponent',
  setup(__props) {

const baseUrl = process.env.VUE_APP_API_URL || "";
const docsUrl = `${baseUrl}/v1/self-service/docs`;
const curlDemo = `curl --location '${baseUrl}/v1/self-service/student/' \\
--header 'Content-Type: application/json' \\
--header 'Authorization: Bearer XXXXXX-XXXX-XXXX-XXXX-XXXXXXXX' \\
--data-raw '{
  "email": "api-test-user@reflective.global",
  "password": "987654321",
  "grade":8,
  "subjects": [
    "MATHS"
  ],
  "firstName": "Test",
  "lastName": "API",
  "school": "Demo",
  "studentNumber": "123456789",
  "classNames": ["5A"]
}'`;
const schoolGroupStore = useSchoolGroupStore();
const store = usePublicApiKeyStore();
const activityLogStore = useActivityLogStore();

const selectedSchoolGroupId = ref<string | null>(null);
const schoolGroupOptions = ref<{ label: string; value: string }[]>([]);

const confirmOpen = ref(false);
const gettingStartedOpen = ref(false);
const submitting = ref(false);
const revealing = ref(false);
const pendingAction = ref<Action | null>(null);

const confirmTitle = computed(() => {
  switch (pendingAction.value) {
    case "create": return "Generate API Key";
    case "regenerate": return "Regenerate API Key";
    case "deactivate": return "Deactivate API Key";
    case "reactivate": return "Reactivate API Key";
    case "delete": return "Delete API Key";
    default: return "";
  }
});

const confirmMessage = computed(() => {
  switch (pendingAction.value) {
    case "create":
      return "A new public API key will be generated for this school group.";
    case "regenerate":
      return "A new token will be issued and the current token will stop working immediately.<br/><br/><strong>Any client using the existing token will be locked out.</strong>";
    case "deactivate":
      return "The key will be disabled and any requests using it will be rejected.<br/><br/><strong>Clients will not be able to access the API until it is reactivated.</strong>";
    case "reactivate":
      return "The key will start accepting requests again.";
    case "delete":
      return "This will permanently remove the API key.<br/><br/><strong>This cannot be undone.</strong>";
    default:
      return "";
  }
});

const confirmButtonClass = computed(() => {
  switch (pendingAction.value) {
    case "delete":
    case "regenerate":
    case "deactivate":
      return "bg-red-600 hover:bg-red-700 focus:ring-red-500";
    default:
      return "bg-blue-600 hover:bg-blue-700 focus:ring-blue-500";
  }
});

function formatDate(value?: string) {
  if (!value) return "—";
  try {
    return new Date(value).toLocaleString();
  } catch {
    return value;
  }
}

function schoolGroupLabel(id: string | null): string {
  if (!id) return "";
  const option = schoolGroupOptions.value.find((o) => o.value === id);
  return option ? ` (${option.label})` : "";
}

function openConfirm(action: Action) {
  pendingAction.value = action;
  confirmOpen.value = true;
}

async function onReveal() {
  if (!store.key) return;
  const key = store.key;
  revealing.value = true;
  try {
    await store.revealKey(key._id);
    // A group/key switch mid-reveal would render group A's plaintext token on
    // group B's panel; bail if the selected key changed while we awaited.
    if (store.key?._id !== key._id) return;
  } catch {
    showToast({ text: "Failed to reveal API key.", type: "error" });
  } finally {
    revealing.value = false;
  }
}

async function onCopy() {
  if (!store.revealedAccessToken || !store.key) return;
  const key = store.key;
  const sgSuffix = schoolGroupLabel(key.schoolGroupId);
  try {
    await navigator.clipboard.writeText(store.revealedAccessToken);
    showToast({ text: "API key copied to clipboard.", type: "success" });
    void activityLogStore.logGenericActivityEvent({
      entityType: "public-api-key",
      entityId: key._id,
      actionType: "read",
      details: {
        note: `Copied public API key ${key._id}${sgSuffix}`,
        metadata: { schoolGroupId: key.schoolGroupId },
      },
    });
  } catch {
    showToast({ text: "Could not copy to clipboard.", type: "error" });
  }
}

async function onConfirm() {
  if (!pendingAction.value || !selectedSchoolGroupId.value) return;
  const sgId = selectedSchoolGroupId.value;
  submitting.value = true;
  try {
    const action = pendingAction.value;
    if (action === "create") {
      await store.createKey(sgId);
      showToast({ text: "API key generated.", type: "success" });
    } else if (store.key) {
      const keyId = store.key._id;
      if (action === "regenerate") {
        await store.regenerateKey(keyId);
        showToast({ text: "API key regenerated. The new token is now available for use.", type: "success" });
      } else if (action === "deactivate") {
        await store.setStatus(keyId, "inactive");
        showToast({ text: "API key deactivated.", type: "success" });
      } else if (action === "reactivate") {
        await store.setStatus(keyId, "active");
        showToast({ text: "API key reactivated.", type: "success" });
      } else if (action === "delete") {
        await store.deleteKey(keyId);
        showToast({ text: "API key deleted.", type: "success" });
      }
    }
    confirmOpen.value = false;
    pendingAction.value = null;
    // Skip the refetch after regenerate: fetchKey resets revealedAccessToken to
    // null, which would mask the freshly-issued token the toast just promised.
    if (
      selectedSchoolGroupId.value &&
      action !== "delete" &&
      action !== "regenerate"
    ) {
      await store.fetchKey(selectedSchoolGroupId.value);
    }
  } catch (error: any) {
    const message = error?.response?.data?.message || "Action failed. Please try again.";
    showToast({ text: message, type: "error" });
  } finally {
    submitting.value = false;
  }
}

onMounted(async () => {
  store.clear();
  await schoolGroupStore.fetchSchoolGroups();
  schoolGroupOptions.value = schoolGroupStore.schoolGroups
    .filter((group: SchoolGroup) => group.status === "active")
    .map((group: SchoolGroup) => ({ label: group.name, value: group._id }))
    .sort((a, b) => a.label.localeCompare(b.label));
});

watch(selectedSchoolGroupId, async (newVal) => {
  store.clear();
  if (newVal) {
    await store.fetchKey(newVal);
  }
});

return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!
  const _component_spinner_loader = _resolveComponent("spinner-loader")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (gettingStartedOpen.value = true)),
            class: "px-3 py-2 bg-blue-600 text-white text-xs font-medium rounded-md hover:bg-blue-700"
          }, " Getting Started "),
          _createElementVNode("a", {
            href: docsUrl,
            target: "_blank",
            rel: "noopener noreferrer",
            class: "px-3 py-2 bg-blue-600 text-white text-xs font-medium rounded-md hover:bg-blue-700"
          }, " API Documentation ")
        ])
      ]),
      _createVNode(_component_FormKit, {
        type: "select",
        label: "",
        placeholder: "Select a School Group",
        name: "schoolGroup",
        modelValue: selectedSchoolGroupId.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedSchoolGroupId).value = $event)),
        "outer-class": "primary-select",
        options: schoolGroupOptions.value,
        classes: { outer: 'w-full sm:w-1/2' }
      }, null, 8, ["modelValue", "options"])
    ]),
    (_unref(store).loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createVNode(_component_spinner_loader)
        ]))
      : (selectedSchoolGroupId.value && !_unref(store).key)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _hoisted_9,
            _hoisted_10,
            _createElementVNode("button", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (openConfirm('create'))),
              class: "bg-blue-600 text-white text-lg px-8 py-3 rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
            }, " Generate API Key ")
          ]))
        : (selectedSchoolGroupId.value && _unref(store).key)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _createElementVNode("span", {
                  class: _normalizeClass(["px-3 py-1 rounded-full text-sm font-medium", _unref(store).key.status === 'active'
            ? 'bg-green-100 text-green-800'
            : 'bg-red-100 text-red-800'])
                }, _toDisplayString(_unref(store).key.status === 'active' ? 'Active' : 'Inactive'), 3)
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", null, [
                  _hoisted_15,
                  _createElementVNode("div", null, _toDisplayString(formatDate(_unref(store).key.createdAt)), 1)
                ]),
                _createElementVNode("div", null, [
                  _hoisted_16,
                  _createElementVNode("div", null, _toDisplayString(formatDate(_unref(store).key.updatedAt)), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _hoisted_18,
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("input", {
                      type: "text",
                      readonly: "",
                      value: revealing.value ? '' : (_unref(store).revealedAccessToken || '••••••••••••••••••••••••••••••••'),
                      class: "w-full px-4 py-3 text-base font-mono bg-gray-50 border border-gray-200 rounded-lg"
                    }, null, 8, _hoisted_21),
                    (revealing.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                          _createVNode(_component_spinner_loader, { color: "text-gray-500" })
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  (!_unref(store).revealedAccessToken)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        onClick: onReveal,
                        class: "px-4 py-3 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200",
                        disabled: revealing.value
                      }, " Show ", 8, _hoisted_23))
                    : (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(store).hideKey())),
                        class: "px-4 py-3 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200"
                      }, " Hide ")),
                  _createElementVNode("button", {
                    onClick: onCopy,
                    disabled: !_unref(store).revealedAccessToken,
                    class: "px-4 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:bg-gray-300 disabled:cursor-not-allowed"
                  }, " Copy ", 8, _hoisted_24)
                ])
              ]),
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("button", {
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (openConfirm('regenerate'))),
                  class: "px-5 py-3 bg-yellow-500 text-white rounded-lg hover:bg-yellow-600"
                }, " Regenerate "),
                (_unref(store).key.status === 'active')
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (openConfirm('deactivate'))),
                      class: "px-5 py-3 bg-orange-500 text-white rounded-lg hover:bg-orange-600"
                    }, " Deactivate "))
                  : (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (openConfirm('reactivate'))),
                      class: "px-5 py-3 bg-green-600 text-white rounded-lg hover:bg-green-700"
                    }, " Reactivate ")),
                _createElementVNode("button", {
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (openConfirm('delete'))),
                  class: "ml-auto px-5 py-3 bg-red-600 text-white rounded-lg hover:bg-red-700"
                }, " Delete ")
              ])
            ]))
          : _createCommentVNode("", true),
    _createVNode(_component_modal, {
      showCloseButton: true,
      widthClass: 'max-w-lg',
      open: confirmOpen.value,
      onLocalModalOpen: _cache[9] || (_cache[9] = ($event: any) => (confirmOpen.value = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("h3", _hoisted_28, _toDisplayString(confirmTitle.value), 1),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("p", {
                class: "text-sm text-gray-600",
                innerHTML: confirmMessage.value
              }, null, 8, _hoisted_30)
            ])
          ]),
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("button", {
              type: "button",
              class: _normalizeClass(["inline-flex w-full justify-center rounded-md border border-transparent px-4 py-2 text-base font-medium text-white shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 sm:ml-3 sm:w-auto sm:text-sm", confirmButtonClass.value]),
              disabled: submitting.value,
              onClick: onConfirm
            }, _toDisplayString(submitting.value ? "Working…" : "Confirm"), 11, _hoisted_32),
            _createElementVNode("button", {
              type: "button",
              class: "mt-3 inline-flex w-full justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-base font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:mt-0 sm:w-auto sm:text-sm",
              disabled: submitting.value,
              onClick: _cache[8] || (_cache[8] = ($event: any) => (confirmOpen.value = false))
            }, " Cancel ", 8, _hoisted_33)
          ])
        ])
      ]),
      _: 1
    }, 8, ["open"]),
    _createVNode(_component_modal, {
      showCloseButton: true,
      widthClass: 'max-w-2xl',
      open: gettingStartedOpen.value,
      onLocalModalOpen: _cache[10] || (_cache[10] = ($event: any) => (gettingStartedOpen.value = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_34, [
          _hoisted_35,
          _hoisted_36,
          _hoisted_37,
          _createElementVNode("section", _hoisted_38, [
            _hoisted_39,
            _createElementVNode("pre", _hoisted_40, _toDisplayString(_unref(baseUrl)), 1)
          ]),
          _createElementVNode("section", { class: "mb-5" }, [
            _hoisted_41,
            _createElementVNode("pre", { class: "bg-gray-50 border border-gray-200 rounded-lg px-4 py-3 text-sm font-mono overflow-x-auto whitespace-pre" }, _toDisplayString(curlDemo))
          ]),
          _createElementVNode("section", null, [
            _hoisted_42,
            _createElementVNode("pre", { class: "bg-gray-50 border border-gray-200 rounded-lg px-4 py-3 text-sm font-mono overflow-x-auto" }, _toDisplayString(expectedResponse))
          ])
        ])
      ]),
      _: 1
    }, 8, ["open"])
  ]))
}
}

})